import React, { useState } from "react";
import Viewer from "./Viewer";
import Keypad from "./Keypad";
import Notepad from "./Notepad";

const NewAnsweringQuestions = ( props ) => {

  const [ answer, setAnswer ] = useState( '' );
  const [ arrow, setArrow ] = useState( '' );
  const [ keypadType, setKeypadType ] = useState( 0 );

  const Inputer = keypadType ? Notepad : Keypad;

  return (
    <div style={ { padding : 20, display : 'inline-flex', width : '100%' } }>
      <Viewer question={ props.children } answer={ answer } arrow={ arrow } />
      <Inputer onSubmit={ setAnswer } onArrow={ setArrow } onChange={ setKeypadType } />
    </div>
  );

};

export default NewAnsweringQuestions;
